export default __webpack_public_path__ + "static/media/svg-2.3bb2c07e.svg";